import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';

import AnimatedNumber from 'src/components/AnimatedNumber';
import React from 'react';
import { chooseUsData } from 'src/resources/data/landingPageData';
import posterImage from '../../resources/images/hero_img_bg.jpg';
import { useInView } from 'react-intersection-observer';

const ChooseUsBanner: React.FC = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { title, subTitle, content } = chooseUsData;
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  const padding = isMobile
    ? { px: 2, py: 4 }
    : isTablet
    ? { px: 4, py: 6 }
    : { px: 10, py: 10 };

  return (
    <Box
      ref={ref}
      display="grid"
      gridTemplateColumns={{ xs: '1fr', sm: "repeat(2, 1fr)", md: 'repeat(2, 1fr)' }}
      minHeight="75vh"
      width="100%"
    >
      <Box
        component="img"
        src={posterImage}
        alt="Choose Us Banner"
        sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
      <Box
        bgcolor="#f26e8d"
        color="#fff"
        {...padding}
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <Typography variant="h3" fontWeight={600} mb={2}>
          {title}
        </Typography>
        <Typography variant="body1" fontSize="1.1rem" fontWeight={300} mb={6}>
          {subTitle}
        </Typography>
        <Stack
          direction={{sx: "column", sm: "row"}}
          spacing={{ xs: 4, sm: 8 }}
          alignItems="center"
          justifyContent="space-around"
        >
          {content.map((item, i) => (
            <Stack key={i} alignItems="center" textAlign="center">
              <AnimatedNumber
                target={item.target}
                suffix={item.suffix}
                inView={inView}
              />
              <Typography variant="body2" mt={1}>
                {item.title}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default ChooseUsBanner;
